import React from "react";
import { FaGithub, FaInstagram, FaPhone } from "react-icons/fa";
import { CiLinkedin } from "react-icons/ci";
import { SiGmail } from "react-icons/si";
import { FaKaggle } from "react-icons/fa";
import { motion } from "framer-motion";

const ContactWrapper = () => {
  const contacts = [
    { name: "GitHub", icon: <FaGithub />, link: "https://github.com/Suryanra" },
    {
      name: "LinkedIn",
      icon: <CiLinkedin />,
      link: "https://www.linkedin.com/in/suryanra/",
    },
    {
      name: "Gmail",
      icon: <SiGmail />,
      link: "mailto:suryapratapnra@gmail.com",
    },
    {
      name: "Kaggle",
      icon: <FaKaggle />,
      link: "https://www.kaggle.com/suryanra",
    },
  ];

  return (
    <div className="ContactWrapper" id="Contact">
      <motion.div
        className="contactHeader"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}>
        Have a project in mind? <span className="redred">Contact Me</span>
      </motion.div>

      <div className="contactContent">
        {contacts.map((contact, index) => (
          <motion.a
            key={index}
            href={contact.link}
            target="_blank"
            className="contactCard"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: index * 0.2 }}
            whileHover={{ scale: 1.1 }}>
            <div className="icon">{contact.icon}</div>
            <div>{contact.name}</div>
          </motion.a>
        ))}
      </div>

      <motion.div
        className="thankyou"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1.5 }}>
        THANK YOU!
      </motion.div>
    </div>
  );
};

export default ContactWrapper;
